import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import MemoryIcon from '@mui/icons-material/Memory';
import SettingsIcon from '@mui/icons-material/Settings';
import TableViewIcon from '@mui/icons-material/TableView';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import type { JSX } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: <DashboardIcon /> },
  { to: '/sources', label: 'Quellen', icon: <TravelExploreIcon /> },
  { to: '/models', label: 'Modelle', icon: <MemoryIcon /> },
  { to: '/matrix', label: 'Freigabematrix', icon: <TableViewIcon /> },
  { to: '/templates', label: 'Vorlagen', icon: <DescriptionIcon /> },
  { to: '/settings', label: 'Einstellungen', icon: <SettingsIcon /> },
];

/** docs/design/MUI-Komponenten.md "Shell": Drawer variant="permanent" mit List/ListItemButton (selected-State). */
export function NavDrawer(): JSX.Element {
  const location = useLocation();

  return (
    <Drawer variant="permanent" data-testid="nav-drawer">
      <List sx={{ mt: '64px' }}>
        {NAV_ITEMS.map((item) => {
          const selected = item.to === '/' ? location.pathname === '/' : location.pathname.startsWith(item.to);
          return (
            <ListItemButton
              key={item.to}
              component={RouterLink}
              to={item.to}
              selected={selected}
              data-testid={`nav-item-${item.label}`}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          );
        })}
      </List>
    </Drawer>
  );
}
